const visileColumns = [
  {
    title: "Check Date",
    field: "Check_Date",
    locked: false,
    filter: "date",
    format: "MM/DD/YYYY",
    editor: "date",
    width: "auto",
    show: true,
  },
  {
    title: "Pay period",
    field: "Pay_Period_Ending_date",
    locked: false,
    filter: "date",
    format: "MM/DD/YYYY",
    editor: "date",
    width: "auto",
    show: true,
  },
  {
    title: "Annual Leave",
    field: "Annual_Leave_Balance",
    locked: false,
    filter: "numeric",
    customFilterType: "CustomNumericText",
    width: "180px",
    show: true,
    className: "text-end",
  },
  {
    title: "Sick Leave",
    field: "Sick_Leave_Balance",
    locked: false,
    filter: "numeric",
    customFilterType: "CustomNumericText",
    width: "180px",
    show: true,
    className: "text-end",
  },
  {
    title: "Rate",
    field: "Hourly_RATE",
    locked: false,
    filter: "numeric",
    customFilterType: "CustomNumericText",
    width: "150px",
    show: true,
    className: "text-end",
  },
  {
    title: "Gross Pay",
    field: "Ppe_Gross_Earnings",
    locked: false,
    filter: "numeric",
    customFilterType: "CustomNumericText",
    width: "200px",
    show: true,
    className: "text-end",
  },
];

export default visileColumns;
